import React from "react";
import { Button } from "@mui/material";
import { useFormik } from "formik";
import { Grid, Box, } from "@mui/material";
import RutaFormFields from "./RutaFormFields";
import TabComponent from "components-base/Tab/Tab";
import { createRuta,modifyRuta, validationSchemaRuta } from "../functions";
import { useDispatch, useSelector } from "react-redux";
import { showMessage } from "store/modules/Message";

const RutaForm = ({ mode, handleClose }) => {
    const {defaultDataRuta} = useSelector(({ruta})=>ruta);
    const dispatch = useDispatch();
    const messages = (mensaje) =>{
        dispatch(
            showMessage({
              message: `Ruta ${mensaje} con éxito`,
              variant: "success",
              anchorOrigin: {
                vertical: "top",
                horizontal: "right",
              },
            })
          );

    }
    const formik = useFormik({
        initialValues:
            mode === "POST"
                ? {
                    nombre: "",
                    descripcion: "",
                    codigo: "",
                    zona: "",
                    region: ""
                }
                : {
                    id: defaultDataRuta?.id,
                    nombre: defaultDataRuta?.nombre,
                    descripcion: defaultDataRuta?.descripcion,
                    region: defaultDataRuta?.region,
                    zona: defaultDataRuta?.zona,
                    codigo: defaultDataRuta?.codigo,
                    operadores:defaultDataRuta?.operadores?.map(item => item.chofer),
                    supervisor:defaultDataRuta?.supervisores?.map(item => item.supervisor)
                },
        validationSchema: validationSchemaRuta,
        onSubmit: async (values) => {
            switch(mode){
                case "POST":
                   await createRuta(values,dispatch);
                    messages("Creado")
                    handleClose();
                break;
                case "PUT":
                  await modifyRuta(values,dispatch);
                    messages("Modificado");
                    handleClose();
                break;
                default:handleClose();
            }
        },
    },);
    const { setFieldValue } = formik;

    return (
        <Box
            component="form"
            onSubmit={formik.handleSubmit}
            sx={{
                "& .MuiTextField-root": { marginBottom: "25px" },
            }}
            style={{ padding: "20px", justifyContent: "center" }}
        >
            <TabComponent tabsElement={[
                {
                    label: "Información de la Ruta",
                    component: <RutaFormFields formik={formik} mode={mode} setFieldValue={setFieldValue} />
                }
            ]} />
            <Grid container
                spacing={2}
                sx={{ display: "flex", justifyContent: "flex-end", padding: 0 }}
            >
                <Grid item sx={12} >
                    <Button onClick={handleClose} color="primary" variant="contained">
                        Cancelar
                    </Button>
                </Grid>
                <Grid item sx={12}>
                    <Button color="primary" variant="contained" type="submit">
                        Guardar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
}
export default RutaForm;